/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerCreateForceFullRerunVersionMutationResponse, ApplicationsControllerCreateForceFullRerunVersionPathParams, ApplicationsControllerCreateForceFullRerunVersion400, ApplicationsControllerCreateForceFullRerunVersion401, ApplicationsControllerCreateForceFullRerunVersion403 } from "../../models/checklistsController/ApplicationsControllerCreateForceFullRerunVersion";

function getApplicationsControllerCreateForceFullRerunVersionUrl(id: ApplicationsControllerCreateForceFullRerunVersionPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/checklist-applications/${id}/versions/force-full-rerun` as const }  
  return res
}

/**
 * @description Admin-only rerun that bypasses carried summaries and regenerates every AI summary.
 * @summary Create a new checklist application version with a full rerun
 * {@link /api/v1/checklist-applications/:id/versions/force-full-rerun}
 */
export async function applicationsControllerCreateForceFullRerunVersion(id: ApplicationsControllerCreateForceFullRerunVersionPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerCreateForceFullRerunVersionMutationResponse, ResponseErrorConfig<ApplicationsControllerCreateForceFullRerunVersion400 | ApplicationsControllerCreateForceFullRerunVersion401 | ApplicationsControllerCreateForceFullRerunVersion403>, unknown>({ method : "POST", url : getApplicationsControllerCreateForceFullRerunVersionUrl(id).url.toString(), ... requestConfig })  
  return res.data
}